module.exports = "\n<table style=\"width:100%\">\n  <tr>\n    <td style=\"width:20%\" >{{product.ATArtikelnummer}}</td>\n    <td style=\"width:40%\" >{{product.ATBezeichnung1}}</td> \n    <td style=\"width:20%; text-align:right\" >{{product.ATLsiLHMBestand}} {{product.ATVPETransport}} </td>\n    <td style=\"width:15%; text-align:right\" >{{product.ATLsiVPEBestand}} {{product.ATVPE}}</td>\n  </tr>\n</table>"


//////////////////
// WEBPACK FOOTER
// D:/Crossplatform/swsLagerinfo/src/app/artikelzeile/artikelzeile.component.html
// module id = ../../../../../src/app/artikelzeile/artikelzeile.component.html
// module chunks = 1